export default __webpack_public_path__ + "static/media/background.3c8efce8.jpg";